import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/gamification')({
  component: GamificationLayout,
});

function GamificationLayout() {
  return <Outlet />;
}
